import React from 'react';

import { Link } from 'react-router-dom';

import { Alert, Stack, Typography } from '@mui/material';

import { InternalPromoWithDiscounts } from '~/services/PromoService';

import EmancipatePromoButton from './EmancipatePromoButton';

interface ParentPromoUsageLimitWarningProps {
  parentPromo: InternalPromoWithDiscounts;
  childPromo?: InternalPromoWithDiscounts;
  onEmancipated?: () => void | Promise<void>;
}

export default function ParentPromoUsageLimitWarning({
  parentPromo,
  childPromo,
  onEmancipated,
}: ParentPromoUsageLimitWarningProps) {
  const usageCount = parentPromo?.usage_count ?? 0;
  const limitPart = parentPromo?.code_limit != null ? parentPromo.code_limit : '—';
  const linkId = parentPromo?.id_promo_code;

  return (
    <Alert severity={typeof limitPart === 'number' && usageCount >= limitPart ? 'error' : 'info'} sx={{ mt: 1 }}>
      <Stack spacing={1.5} alignItems="flex-start">
        <Typography variant="body2" component="span">
          As a child promo, the parent promo usage limit{' '}
          <strong>
            (currently: {usageCount}/{limitPart})
          </strong>{' '}
          (
          <Link to={`/promos/code/${encodeURIComponent(linkId)}`} target="_blank" rel="noreferrer">
            parent promo
          </Link>
          ) also applies to this promo code.
          <br />
        </Typography>
        <Typography variant="body2" component="span">
          To avoid the parent promo limit being applied to this promo, you can emancipate it from the parent promo:
          {childPromo && onEmancipated ? (
            <EmancipatePromoButton childPromo={childPromo} parentPromo={parentPromo} onSuccess={onEmancipated} />
          ) : null}
        </Typography>
        <Typography variant="body2" component="span">
          (this promo's limit is currently: {childPromo?.usage_count ?? 0}/{childPromo?.code_limit ?? '—'})
        </Typography>
      </Stack>
    </Alert>
  );
}
